import { z } from 'zod'

import { AiAutomationTovState, tovSampleSchema } from 'shared/api/requests/aiToneOfVoice/schemas'
import { SocketEventBaseSchema } from 'utils/services/notificationsService/constants'

export const ToneOfVoiceSocketEventsSchemas = {
  samplesGenerated: SocketEventBaseSchema.extend({
    event: z.literal('ai_tov_samples_generated'),
    samples: z.array(tovSampleSchema),
  }),

  stateUpdated: SocketEventBaseSchema.extend({
    event: z.literal('ai_tov_setup_state_updated'),
    state: z.enum(AiAutomationTovState),
  }),
}
